// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emailCheck_mainWrapper__cXGiu {
    height: -moz-fit-content;
    height: fit-content;
    padding: 0 10px;
  }
  
  .emailCheck_wrapperTooltip__yFWpF.emailCheck_wrapperTooltip__yFWpF {
    background-color: transparent;
    padding: 0;
  }
  
  .emailCheck_tooltip__GC8Un.emailCheck_tooltip__GC8Un {
    background-color: #fff;
    border-radius: 8px;
  }
  
  .emailCheck_tooltip__GC8Un.emailCheck_tooltip__GC8Un span {
    color: var(--color-black-500, #577487);
  }
  
  .emailCheck_tooltip__GC8Un.emailCheck_tooltip__GC8Un button span {
    color: var(--color-black-main, #364954);
  }
  
  .emailCheck_tooltip__GC8Un.emailCheck_tooltip__GC8Un button:hover {
    background-color: #45dcc6;
  }
  
  .emailCheck_tooltip__GC8Un.emailCheck_tooltip__GC8Un button:active {
    background-color: #0c6154;
  }
  
  .emailCheck_tooltip__GC8Un.emailCheck_tooltip__GC8Un button:active span {
    color: #fff;
  }
  
  .emailCheck_lngButton__dHolP {
    color: #678aa1;
  }
  
  .emailCheck_lngActive__SUqyC {
    color: #55bbeb;
  }
  
  .emailCheck_tooltipWrapper__mXq-s {
    position: relative;
    display: inline-block;
    cursor: pointer; 
  }
  
  .emailCheck_tooltipText__BFblX {
    visibility: hidden; 
    width: 150px;
    background-color: rgba(0, 0, 0, 0.75); 
    color: #fff; 
    text-align: center;
    border-radius: 4px; 
    padding: 5px 10px; 
    position: absolute;
    z-index: 10000 !important; 
    bottom: 125%; 
    left: 50%;
    transform: translateX(-50%);
    opacity: 0; 
    transition: opacity 0.3s ease-in-out;
    font-size: 12px;
    pointer-events: none; 
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); 
  }
  
  .emailCheck_tooltipWrapper__mXq-s:hover .emailCheck_tooltipText__BFblX {
    visibility: visible;
    opacity: 1;
    position: absolute;
  }
  
  .emailCheck_errorIcon__HwKg9 {
    color: red; /* Цвет иконки */
    width: 16px; /* Размер иконки */
    height: 13px;
    display: inline-block;
  }
  
  
  .emailCheck_inputField__Jbtzl {
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    width: 100%;
    min-width: 150px;
  }
  
  
  .emailCheck_formWrapper__ZoA1v {
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    overflow-y: scroll;
  }
  
  .emailCheck_registrationTitle__0VOp6 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 24px;
    max-width: 1080px;
  }
  
  .emailCheck_registrationConfigRoot__5kt0F {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
  }
  
  .emailCheck_labelAndButtonWrapper__hs8\\+1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .emailCheck_titleWrapper__nk0qV {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
  
  .emailCheck_checkboxWraper__ncThx {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-bottom: 10px;
    gap: 8px;
  }
  
  .emailCheck_labelCheckBox__l5WcB {
    font-size: 14px;
    font-weight: 500;
  }
  
  .emailCheck_labelAndErrorWrapper__mW-ZF {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
  }
  
  .emailCheck_orgTitleMain__sVMkO {
    font-weight: 600;
  }
  
  @media screen and (max-width: 600px) {
    .emailCheck_label-and-error-wrapper__INbf9 {
      margin-top: 10px;
    }
  }
  
  .emailCheck_subjectBlockConfigRoot__1WrU4 {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    margin-bottom: 12px;
  }
  
  .emailCheck_blockConfigRoot__KcUtd {
    background-color: #fff;
    border-radius: 8px;
    padding: 8px 24px;
    gap: 10px;
    width: 100%;
    max-width: 1080px;
  }
  
  .emailCheck_buttonBlock__jRgau {
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    max-width: 100%;
    margin-bottom: 16px;
  }
  
  .emailCheck_buttonConfigRoot__lvqta {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .emailCheck_formAddButton__K1uzP {
    background-color: #fff;
    width: 100%;
    border-radius: 8px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  
  .emailCheck_formAddButton__K1uzP span {
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
  }
  
  .emailCheck_formAddButton__K1uzP img {
    flex-shrink: 0;
  }
  
  .emailCheck_formAddButton__K1uzP:hover {
    background-color: #f3f7f7;
  }
  
  .emailCheck_formButton__IboHg {
    display: flex;
    flex-direction: row;
    max-width: 100%;
    gap: 8px;
  }
  
  .emailCheck_inputField__Jbtzl {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(33% - 8px); */
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    width: 100%;
    min-width: 150px;
  }
  
  .emailCheck_inputField1__\\+65tP {
    /* max-width: 256px; */
    /* flex: 1 1 calc(50% - 10px); */
    /* max-width: calc(50% - 8px); */
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    color: #2e3138;
    margin-bottom: 8px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 10px);
    width: 100%;
    min-width: 150px;
  }
  
  .emailCheck_inputField2__aWgXF {
    position: relative;
    
    max-width: 300px;
  }
  
  .emailCheck_inputLabel2__ZI4cb {
    font-size: 14px;
    color: #374151;
    font-weight: 500;
  }
  
  .emailCheck_inputFieldNoOwerflow__da0EP {
    overflow: visible;
  }
  
  .emailCheck_inputField1__\\+65tP .emailCheck_placeholder__meeIr,
  .emailCheck_inputField1__\\+65tP input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 14px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  
  .emailCheck_inputField2__aWgXF .emailCheck_placeholder__meeIr,
  .emailCheck_inputField2__aWgXF input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 14px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  
  .emailCheck_selectField__8Uyf9 {
    width: 100%;
    height: 48px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    padding: 8px;
    margin: 0;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
  }
  
  .emailCheck_inputField__Jbtzl .emailCheck_placeholder__meeIr,
  .emailCheck_inputField__Jbtzl input {
    width: 100%;
    height: 40px;
    border: 1px solid #a3c0d2;
    border-radius: 10px;
    padding-left: 10px;
    font-size: 12px;
    color: #2e3138;
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 19.6px;
    margin: 0;
    outline: none;
  }
  
  .emailCheck_inputField__Jbtzl input:hover {
    border-color: #8ea3b0;
  }
  
  .emailCheck_inputField__Jbtzl input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .emailCheck_inputField__Jbtzl input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .emailCheck_inputField__Jbtzl input.emailCheck_-error__uXaZq {
    border-color: #ed1e1e;
  }
  
  .emailCheck_inputField1__\\+65tP input:hover {
    border-color: #8ea3b0;
  }
  
  .emailCheck_inputField1__\\+65tP input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .emailCheck_inputField1__\\+65tP input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .emailCheck_inputField2__aWgXF input.emailCheck_-error__uXaZq {
    border-color: #ed1e1e;
  }
  
  .emailCheck_inputField2__aWgXF input:hover {
    border-color: #8ea3b0;
  }
  
  .emailCheck_inputField2__aWgXF input:focus {
    border-color: #0c6154;
    border-width: 1px;
  }
  
  .emailCheck_inputField2__aWgXF input::placeholder {
    color: #a3c0d2;
    font-weight: 400;
    font-size: 14px;
  }
  
  .emailCheck_inputField2__aWgXF input.emailCheck_-error__uXaZq {
    border-color: #ed1e1e;
  }
  
  .emailCheck_buttonForm__8-Yzj {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33% - 8px);
  }
  
  .emailCheck_errorLabel__wb2s8 {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: rgb(249, 52, 30);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .emailCheck_labelAndErrorWrapper__mW-ZF {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    align-items: center;
  }
  
  .emailCheck_modalHeader__MDxxE{
    display:flex;
    flex-direction: column;
    width:100%;
    padding:20px;
    min-width:500px;
    gap:20px;
  }
  .emailCheck_modalTitle__eOvci{
    font-size: 12px;
    font-family: Inter;
  }
  .emailCheck_modalDesc__Mm\\+5k{
    font-size: 12px;
    font-family: Inter;
    font-weight: 400;
    max-width: 500px;
  }
  .emailCheck_HorLine__mDz8j{
    width:100%;
    background-color: #d1d1d1;
    padding:4px 0px 0px 0px;
  }`, "",{"version":3,"sources":["webpack://./src/shared/EmailCheck/emailCheck.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,oCAAoC;IACpC,eAAe;IACf,oBAAoB;IACpB,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU,EAAE,gBAAgB;IAC5B,WAAW,EAAE,kBAAkB;IAC/B,YAAY;IACZ,qBAAqB;EACvB;;;EAGA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;;EAGA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;;IAElB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,QAAQ;EACV;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,uBAAuB;EACzB","sourcesContent":[".mainWrapper {\n    height: fit-content;\n    padding: 0 10px;\n  }\n  \n  .wrapperTooltip.wrapperTooltip {\n    background-color: transparent;\n    padding: 0;\n  }\n  \n  .tooltip.tooltip {\n    background-color: #fff;\n    border-radius: 8px;\n  }\n  \n  .tooltip.tooltip span {\n    color: var(--color-black-500, #577487);\n  }\n  \n  .tooltip.tooltip button span {\n    color: var(--color-black-main, #364954);\n  }\n  \n  .tooltip.tooltip button:hover {\n    background-color: #45dcc6;\n  }\n  \n  .tooltip.tooltip button:active {\n    background-color: #0c6154;\n  }\n  \n  .tooltip.tooltip button:active span {\n    color: #fff;\n  }\n  \n  .lngButton {\n    color: #678aa1;\n  }\n  \n  .lngActive {\n    color: #55bbeb;\n  }\n  \n  .tooltipWrapper {\n    position: relative;\n    display: inline-block;\n    cursor: pointer; \n  }\n  \n  .tooltipText {\n    visibility: hidden; \n    width: 150px;\n    background-color: rgba(0, 0, 0, 0.75); \n    color: #fff; \n    text-align: center;\n    border-radius: 4px; \n    padding: 5px 10px; \n    position: absolute;\n    z-index: 10000 !important; \n    bottom: 125%; \n    left: 50%;\n    transform: translateX(-50%);\n    opacity: 0; \n    transition: opacity 0.3s ease-in-out;\n    font-size: 12px;\n    pointer-events: none; \n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3); \n  }\n  \n  .tooltipWrapper:hover .tooltipText {\n    visibility: visible;\n    opacity: 1;\n    position: absolute;\n  }\n  \n  .errorIcon {\n    color: red; /* Цвет иконки */\n    width: 16px; /* Размер иконки */\n    height: 13px;\n    display: inline-block;\n  }\n  \n  \n  .inputField {\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  \n  .formWrapper {\n    padding-top: 20px;\n    padding-bottom: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    overflow-y: scroll;\n  }\n  \n  .registrationTitle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 0 24px;\n    max-width: 1080px;\n  }\n  \n  .registrationConfigRoot {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 16px;\n  }\n  \n  .labelAndButtonWrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n  \n  .titleWrapper {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n  \n  .checkboxWraper {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    gap: 8px;\n  }\n  \n  .labelCheckBox {\n    font-size: 14px;\n    font-weight: 500;\n  }\n  \n  .labelAndErrorWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n  }\n  \n  .orgTitleMain {\n    font-weight: 600;\n  }\n  \n  @media screen and (max-width: 600px) {\n    .label-and-error-wrapper {\n      margin-top: 10px;\n    }\n  }\n  \n  .subjectBlockConfigRoot {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px 16px;\n    margin-bottom: 12px;\n  }\n  \n  .blockConfigRoot {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 8px 24px;\n    gap: 10px;\n    width: 100%;\n    max-width: 1080px;\n  }\n  \n  .buttonBlock {\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n    max-width: 100%;\n    margin-bottom: 16px;\n  }\n  \n  .buttonConfigRoot {\n    background-color: #fff;\n    border-radius: 8px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .formAddButton {\n    background-color: #fff;\n    width: 100%;\n    border-radius: 8px;\n    padding: 10px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .formAddButton span {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n    overflow: hidden;\n  }\n  \n  .formAddButton img {\n    flex-shrink: 0;\n  }\n  \n  .formAddButton:hover {\n    background-color: #f3f7f7;\n  }\n  \n  .formButton {\n    display: flex;\n    flex-direction: row;\n    max-width: 100%;\n    gap: 8px;\n  }\n  \n  .inputField {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(33% - 8px); */\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    flex: 1 1 calc(50% - 10px);\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  .inputField1 {\n    /* max-width: 256px; */\n    /* flex: 1 1 calc(50% - 10px); */\n    /* max-width: calc(50% - 8px); */\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    color: #2e3138;\n    margin-bottom: 8px;\n    flex: 1 1 calc(33% - 10px);\n    width: 100%;\n    min-width: 150px;\n  }\n  \n  .inputField2 {\n    position: relative;\n    \n    max-width: 300px;\n  }\n  \n  .inputLabel2 {\n    font-size: 14px;\n    color: #374151;\n    font-weight: 500;\n  }\n  \n  .inputFieldNoOwerflow {\n    overflow: visible;\n  }\n  \n  .inputField1 .placeholder,\n  .inputField1 input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 14px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  \n  .inputField2 .placeholder,\n  .inputField2 input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 14px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  \n  .selectField {\n    width: 100%;\n    height: 48px;\n    flex: 1 1 calc(50% - 10px);\n    padding: 8px;\n    margin: 0;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n  }\n  \n  .inputField .placeholder,\n  .inputField input {\n    width: 100%;\n    height: 40px;\n    border: 1px solid #a3c0d2;\n    border-radius: 10px;\n    padding-left: 10px;\n    font-size: 12px;\n    color: #2e3138;\n    font-family: \"Inter\", sans-serif;\n    font-weight: 500;\n    line-height: 19.6px;\n    margin: 0;\n    outline: none;\n  }\n  \n  .inputField input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .inputField1 input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField1 input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField1 input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField2 input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .inputField2 input:hover {\n    border-color: #8ea3b0;\n  }\n  \n  .inputField2 input:focus {\n    border-color: #0c6154;\n    border-width: 1px;\n  }\n  \n  .inputField2 input::placeholder {\n    color: #a3c0d2;\n    font-weight: 400;\n    font-size: 14px;\n  }\n  \n  .inputField2 input.-error {\n    border-color: #ed1e1e;\n  }\n  \n  .buttonForm {\n    flex: 1 1 calc(33% - 8px);\n  }\n  \n  .errorLabel {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 14px;\n    color: rgb(249, 52, 30);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  \n  .labelAndErrorWrapper {\n    display: flex;\n    justify-content: space-between;\n    overflow: hidden;\n    align-items: center;\n  }\n  \n  .modalHeader{\n    display:flex;\n    flex-direction: column;\n    width:100%;\n    padding:20px;\n    min-width:500px;\n    gap:20px;\n  }\n  .modalTitle{\n    font-size: 12px;\n    font-family: Inter;\n  }\n  .modalDesc{\n    font-size: 12px;\n    font-family: Inter;\n    font-weight: 400;\n    max-width: 500px;\n  }\n  .HorLine{\n    width:100%;\n    background-color: #d1d1d1;\n    padding:4px 0px 0px 0px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainWrapper": `emailCheck_mainWrapper__cXGiu`,
	"wrapperTooltip": `emailCheck_wrapperTooltip__yFWpF`,
	"tooltip": `emailCheck_tooltip__GC8Un`,
	"lngButton": `emailCheck_lngButton__dHolP`,
	"lngActive": `emailCheck_lngActive__SUqyC`,
	"tooltipWrapper": `emailCheck_tooltipWrapper__mXq-s`,
	"tooltipText": `emailCheck_tooltipText__BFblX`,
	"errorIcon": `emailCheck_errorIcon__HwKg9`,
	"inputField": `emailCheck_inputField__Jbtzl`,
	"formWrapper": `emailCheck_formWrapper__ZoA1v`,
	"registrationTitle": `emailCheck_registrationTitle__0VOp6`,
	"registrationConfigRoot": `emailCheck_registrationConfigRoot__5kt0F`,
	"labelAndButtonWrapper": `emailCheck_labelAndButtonWrapper__hs8+1`,
	"titleWrapper": `emailCheck_titleWrapper__nk0qV`,
	"checkboxWraper": `emailCheck_checkboxWraper__ncThx`,
	"labelCheckBox": `emailCheck_labelCheckBox__l5WcB`,
	"labelAndErrorWrapper": `emailCheck_labelAndErrorWrapper__mW-ZF`,
	"orgTitleMain": `emailCheck_orgTitleMain__sVMkO`,
	"label-and-error-wrapper": `emailCheck_label-and-error-wrapper__INbf9`,
	"subjectBlockConfigRoot": `emailCheck_subjectBlockConfigRoot__1WrU4`,
	"blockConfigRoot": `emailCheck_blockConfigRoot__KcUtd`,
	"buttonBlock": `emailCheck_buttonBlock__jRgau`,
	"buttonConfigRoot": `emailCheck_buttonConfigRoot__lvqta`,
	"formAddButton": `emailCheck_formAddButton__K1uzP`,
	"formButton": `emailCheck_formButton__IboHg`,
	"inputField1": `emailCheck_inputField1__+65tP`,
	"inputField2": `emailCheck_inputField2__aWgXF`,
	"inputLabel2": `emailCheck_inputLabel2__ZI4cb`,
	"inputFieldNoOwerflow": `emailCheck_inputFieldNoOwerflow__da0EP`,
	"placeholder": `emailCheck_placeholder__meeIr`,
	"selectField": `emailCheck_selectField__8Uyf9`,
	"-error": `emailCheck_-error__uXaZq`,
	"buttonForm": `emailCheck_buttonForm__8-Yzj`,
	"errorLabel": `emailCheck_errorLabel__wb2s8`,
	"modalHeader": `emailCheck_modalHeader__MDxxE`,
	"modalTitle": `emailCheck_modalTitle__eOvci`,
	"modalDesc": `emailCheck_modalDesc__Mm+5k`,
	"HorLine": `emailCheck_HorLine__mDz8j`
};
export default ___CSS_LOADER_EXPORT___;
